<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text>
        <strong
          >KCPSプライベートアクセスルーター再起動を実行します。よろしいですか？</strong
        >
        <br />
        <strong
          >（再起動中は数分程度の通信断が発生する可能性があります）</strong
        >
        <v-container fluid class="pl-0">
          <v-row>
            <v-col>
              <app-label-group label="VNコネクト番号" :value="wnumber" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "KcpsPrivateAccessRouterRestart",
  components: { AppLabelGroup },
  props: {
    /** VNコネクト番号 */
    wnumber: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
</script>
